export const holidays = state => state.getIn(['holidays', 'entities']);
export const holidayByDate = (state, date) => holidays(state).get(String(date));
export const holidaysByDates = (state, dates) => dates.map(date => holidayByDate(state, date));
